'use client'

import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy/dist/components/TypeStyle'

import { gql } from '../../../../../__generated__/graphql/catalog'
import { RichTextSectionFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'
import { ContentfulRichDocumentAsFigsComponents } from '../../../../../lib/utils/contentful'

export const richTextQueryFragment = gql(`
  fragment RichTextSectionFragment on RichTextSection {
    __typename  
    id
    content
  }
`)

export type ContentfulRichTextProps = Omit<RichTextSectionFragmentFragment, '__typename' | 'id'> & {
  className?: string
  fontWeight?: string
  bodySize?: keyof typeof TypeStyle
  mobileBodySize?: keyof typeof TypeStyle
}

const Content = styled.div`
  &,
  a,
  a:hover {
    color: inherit;
    border-color: inherit;
  }

  li {
    padding-inline-start: 24px;
    position: relative;

    &::before {
      background-color: ${o => o.theme.color.text.primary.on.background};
      border-radius: 50%;
      content: '';
      height: 2px;
      margin-inline-start: -15px;
      position: absolute;
      top: 11px;
      transform: translate(0px, -50%);
      width: 2px;
    }
  }
`

export const ContentfulRichText = ({
  className,
  content,
  bodySize,
  fontWeight,
}: ContentfulRichTextProps) => {
  return (
    <Content className={className}>
      <ContentfulRichDocumentAsFigsComponents
        contentfulDocument={content}
        options={{
          bodyFontSize: bodySize,
          bodyFontWeight: fontWeight,
        }}
      />
    </Content>
  )
}
